import type { Champ, Condition } from '@funo/grammaire'

export interface SourceCondition {
  fait: string
  nom: string
  type?: string
  options?: Champ['options']
}

export type ComparaisonSimple = 'est' | 'pas' | 'min' | 'max'

export function conditionInitiale(source: SourceCondition): Condition {
  return {
    champ: source.fait,
    est: source.type === 'oui_non'
      ? true
      : source.type === 'nombre'
        ? 0
        : (source.options?.[0]?.valeur ?? ''),
  }
}

export function comparerCondition(
  source: SourceCondition,
  operateur: ComparaisonSimple,
  valeur: unknown,
): Condition {
  const contenu = source.type === 'oui_non'
    ? valeur === true || valeur === 'true'
    : source.type === 'nombre'
      ? Number(valeur)
      : String(valeur ?? '')
  return { champ: source.fait, [operateur]: contenu } as Condition
}

/** Retirer une branche conserve toutes les autres, y compris les opérateurs avancés. */
export function changerSousCondition(
  condition: Extract<Condition, { tout: Condition[] } | { un_de: Condition[] }>,
  index: number,
  valeur?: Condition,
): Condition | undefined {
  const mode = 'tout' in condition ? 'tout' : 'un_de'
  const conditions = ('tout' in condition ? condition.tout : condition.un_de)
    .flatMap((c, i) => i !== index ? [c] : valeur ? [valeur] : [])
  if (!conditions.length) return undefined
  if (conditions.length === 1) return conditions[0]
  return mode === 'tout' ? { tout: conditions } : { un_de: conditions }
}

export function resumeCondition(condition: Condition): string {
  if ('tout' in condition) return `${condition.tout.length} conditions · ET`
  if ('un_de' in condition) return `${condition.un_de.length} conditions · OU`
  if ('non' in condition) return 'Condition inversée'
  return 'Condition'
}
